import { useState } from 'react';
import {
  desktop_breakpoint_extended,
  desktop_breakpoint,
  tablet_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import useWindowResize from 'pubweb-smokey/dist/hooks/useWindowResize';

export function useHomeCardAspectRatio() {
  const [aspectRatio, setAspectRatio] = useState({
    width: 341,
    height: 243,
  });
  useWindowResize(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > desktop_breakpoint) {
        setAspectRatio({
          width: 348,
          height: 249,
        });
      } else if (window.innerWidth > tablet_breakpoint) {
        //Max size of single column.
        if (window.innerWidth > 600) {
          setAspectRatio({
            width: 512,
            height: 365,
          });
        } else {
          setAspectRatio({
            width: 308,
            height: 220,
          });
        }
      } else {
        setAspectRatio({
          width: 350,
          height: 250,
        });
      }
    }
  }, [desktop_breakpoint_extended, desktop_breakpoint, tablet_breakpoint]);

  return { aspectRatio };
}
